import { createContext, useContext } from 'react'

import type { OverlayContentLayout } from '@/hooks/useOverlayContentLayout'

const defaultLayout: OverlayContentLayout = {
  contentAbove: true,
  contentOnRight: true,
  effectivePosition: 'bottom-left',
  iconWidth: 48,
  iconHeight: 48,
}

const OverlayLayoutContext = createContext<OverlayContentLayout>(defaultLayout)

export const OverlayLayoutProvider = OverlayLayoutContext.Provider

export function useOverlayLayout() {
  return useContext(OverlayLayoutContext)
}
